import styled from "styled-components";

export const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  padding: 10px 250px 50px 90px;

  @media (max-width: 414px) {
    padding: 50px;
  }

  @media (max-width: 280px) {
    padding: 30px;
  }
`;

export const Title = styled.h2`
  margin-top: 0.625rem;
  font-family: "Roboto", sans-serif;
  font-size: 1.2rem;
  color: #007aff;
  font-weight: 700;
`;

export const Form = styled.form`
  margin-top: 30px;
  width: 90%;
  color: #333;

  @media (max-width: 360px) {
    margin-top: -10px;
  }

  h2 {
    color: #007aff;
    font-size: 1.2rem;
  }

  label {
    font-family: "Roboto", sans-serif;
  }
`;
